<template>
  <div class="ui segment">
    <h2 v-if="!isCustomerOwned">Paid Shrpa Creator Visit</h2>
    <h3 v-if="!isCustomerOwned" style="display: inline; margin-right: 15px">{{ collab.communityName }} - {{ collab.collabName }}</h3>
    <h3 v-else style="display: inline; margin-right: 15px">Created from: {{ collab.collabName }}</h3>
    <SrpButton size="tiny" fill="outlined" @click="emit('click:viewCollab')">View Creator Visit</SrpButton>
    <div v-if="!isCustomerOwned" style="font-size: 1.1em; margin-top: 15px">
      <LinkWithIcon tag="a" :href="Links.ExternalLinks.CreatorCollabAdvExp" target="_blank" color="blue">
        <template #icon>
          <IconEmbedded name="external-link_2" />
        </template>
        <span>Shrpa's Creator Visit expectations</span>
      </LinkWithIcon>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CreatorCollabSummary } from "@contracts/collab";
import Links from "@logic/ExternalLinks";
import SrpButton from "@components/ui/SrpButton.vue";
import LinkWithIcon from "@components/LinkWithIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

defineProps<{
  collab: CreatorCollabSummary;
  isCustomerOwned: boolean;
}>();
const emit = defineEmits<{
  (e: "click:viewCollab"): void;
}>();
</script>

<style scoped lang="scss"></style>
